import {Component, Inject, OnInit} from '@angular/core';
import {Broadcast} from "../../model/broadcast/broadcast";
import {BroadcastsService} from "../../services/broadcasts.service";
import {UntypedFormControl, UntypedFormGroup, ReactiveFormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-reset-dialog',
    templateUrl: './reset-dialog.component.html',
    styleUrls: ['./reset-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
        NgIf
    ]
})
export class ResetDialogComponent implements OnInit {
  public formData: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ResetDialogComponent>,
    private broadcastService: BroadcastsService,
    @Inject(MAT_DIALOG_DATA) public broadcast: Broadcast,
  ) { }

  ngOnInit(): void {
    this.formData = new UntypedFormGroup({
      homePitches: new UntypedFormControl(this.broadcast.manualData.homePitches, []),
      awayPitches: new UntypedFormControl(this.broadcast.manualData.awayPitches, []),
    });
  }

  clear(formContolName: string): void {
    this.formData.get(formContolName).reset();
  }

  isSet(formContolName: string): boolean {
    return !!this.formData.get(formContolName).value;
  }

  confirm() {
    this.broadcast.manualData.awayPitches = this.formData.getRawValue().awayPitches;
    this.broadcast.manualData.homePitches = this.formData.getRawValue().homePitches;
    this.broadcastService.updateManualData(this.broadcast).finally(() => {
      this.dialogRef.close();
    });
  }

  close() {
    this.dialogRef.close();
  }
}
